module.exports = __webpack_public_path__ + "static/media/lobo_ong_ngoai-min.2aaffccb.JPG";